import { Type } from "class-transformer";
import { IsDate } from "class-validator";
import { InputEntity, RequestEntity } from "../../..";

export default class TransmedCertificate {
  @Type(() => Date)
  @IsDate()
  public readonly start!: Date;

  @Type(() => Date)
  @IsDate()
  public readonly end!: Date;
}

export class RequestTransmedCertificateValidation extends RequestEntity {
  public constructor(public readonly id: number) {
    super();
  }
}

export class InputTransmedCertificateValidation extends InputEntity {
  public constructor(public readonly message: string | null = null) {
    super();
  }
}
